import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { getTrackSize, getTrackBorderRadius, getProgressSize } from '../helpers/Track.helpers.js';

var _excluded = ["direction", "size", "position", "progress"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useSolidTrack = function useSolidTrack(_ref) {
  var _ref$direction = _ref.direction,
    direction = _ref$direction === void 0 ? 'horizontal' : _ref$direction,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'default' : _ref$size,
    _ref$position = _ref.position,
    position = _ref$position === void 0 ? 'default' : _ref$position,
    _ref$progress = _ref.progress,
    progress = _ref$progress === void 0 ? 100 : _ref$progress,
    rest = _objectWithoutProperties(_ref, _excluded);
  var dimension = {
    width: direction === 'vertical' ? getTrackSize(size) : '100%',
    height: direction === 'vertical' ? '100%' : getTrackSize(size)
  };
  var baseBorderRadius = getTrackBorderRadius(direction, 'default', position);
  var borderRadius = getTrackBorderRadius(direction, size, position);
  var containerProps = _objectSpread({
    width: direction === 'vertical' ? getProgressSize(size) : '100%',
    height: direction === 'vertical' ? '100%' : getProgressSize(size),
    display: 'flex',
    position: 'relative'
  }, direction === 'vertical' ? {
    justifyContent: 'center'
  } : {
    alignItems: 'center'
  });
  var trackProps = _objectSpread(_objectSpread({
    position: 'absolute',
    borderRadius: baseBorderRadius,
    backgroundColor: 'state.inactive.subtle',
    overflow: 'hidden'
  }, dimension), rest);
  var progressProps = {
    position: 'absolute',
    borderRadius: borderRadius,
    width: direction === 'horizontal' ? "".concat(progress, "%") : '100%',
    height: direction === 'vertical' ? "".concat(progress, "%") : '100%',
    backgroundColor: 'base.intent'
  };
  return {
    containerProps: containerProps,
    trackProps: trackProps,
    progressProps: progressProps
  };
};

export { useSolidTrack };
//# sourceMappingURL=useTrack.js.map
